import parse from 'html-react-parser'
import React, { ChangeEvent, FC, useCallback, useState } from 'react'

export type Props = {
  goNextStep: (email: string) => void
}

const mail_format = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

export const Welcome: FC<Props> = ({ goNextStep }) => {
  const [buttonState, setButton] = useState<number>(0)
  const [email, setEmail] = useState<string>('')

  // TODO Parse input data
  const dataItem = document.getElementById('custom-sizes-welcome')
  const data = dataItem !== null ? JSON.parse(dataItem.innerText) : null

  const emailValidation = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (mail_format.test(e.target.value)) {
      setEmail(e.target.value)
      setButton(1)
    } else {
      setButton(0)
    }
  }, [])

  const goNext = useCallback(() => {
    goNextStep(email)
  }, [goNextStep, email])

  if (data == null) {
    return null
  }

  return (
    <div className="CSWelcome" style={{ backgroundColor: data.bg_color }}>
      <div
        className="CSWelcome-pattern"
        style={{
          opacity: data.opacity,
          backgroundImage: `url(${data.pattern})`
        }}
      ></div>

      {/* IMAGE */}
      <div className="CSWelcome-imgContainer">
        <h1 className="CSWelcome-title mobile" style={{ color: data.color }}>
          {data.title}
        </h1>
        <div
          style={{ backgroundImage: `url(${data.image_mobile})` }}
          className="CSWelcome-img mobile"
        ></div>
        <div
          style={{ backgroundImage: `url(${data.image})` }}
          className="CSWelcome-img desktop"
        ></div>
      </div>

      {/* CONTENT */}
      <div className="CSWelcome-content">
        <h1 className="CSWelcome-title desktop" style={{ color: data.color }}>
          {data.title}
        </h1>
        <div className="CSWelcome-text" style={{ color: data.color }}>
          {parse(data.text)}
        </div>
        <div className="CSWelcome-form">
          <input
            placeholder={data.input_placeholder}
            className="CSWelcome-input"
            onChange={emailValidation}
          />
          <button
            className={`o-button ${data.button_color} CSWelcome-btn`}
            disabled={!buttonState}
            onClick={goNext}
            tabIndex={0}
          >
            {data.cta}
          </button>
        </div>
      </div>
    </div>
  )
}
